// extracted by mini-css-extract-plugin
export default {"appMenu":"V_1p4GOo8Zhs4bCBIiqM","menuOpen":"ccJ_Adlr9EFfbnRW9yQu","closeMenu":"kNYVOxsO4u6m3jdLDom6"};